/*
Adjust color brightness/darkness - takes in:
    - a 'hex' string val ('#F56C76') and;
    - a 'lum' number i.e. luminance val (0.2 = 20% brighter, -0.2 = 20% darker)
*/
export const luminance = (hex: string, lum: number): string => {
  // Validate hex string - remove '#' & expand if 3 val hex '#FFF'
  let hexInput = hex.replace(/[^0-9a-f]/gi, '');
  if (hexInput.length < 6) {
    hexInput = hexInput[0] + hexInput[0] + hexInput[1] + hexInput[1] + hexInput[2] + hexInput[2];
  }
  const lumInput = lum || 0;

  // convert to decimal and adjust luminance
  let hexOutput = '#';
  let c;
  let i;
  for (i = 0; i < 3; i += 1) {
    c = parseInt(hexInput.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + (c * lumInput)), 255)).toString(16);
    hexOutput += (`00${c}`).substr(c.length);
  }
  return hexOutput;
};

export default { luminance };
